"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var getFieldSchemaName = function getFieldSchemaName() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var clearedName = name.replace(/\[\d+\]/g, '');

  if (/\.?([^.]+)$/.test(clearedName)) {
    clearedName = RegExp.$1;
  }

  return clearedName;
};

exports.getFieldSchemaName = getFieldSchemaName;